export default "__VITE_ASSET__191c259b__"